export default "__VITE_ASSET__sckc1G9e__"